import { render } from "./Molde-Aberto.vue?vue&type=template&id=473b300e&scoped=true"
import script from "./Molde-Aberto.vue?vue&type=script&lang=js"
export * from "./Molde-Aberto.vue?vue&type=script&lang=js"

import "./Molde-Aberto.vue?vue&type=style&index=0&id=473b300e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473b300e"]])

export default __exports__